import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./style.css";
import certificateImg from "./assets/global-payment-img.png";
import bgImage from "./assets/background-img.jpg";

import {
  FaChartPie,
  FaGem,
  FaMapMarkerAlt,
  FaFingerprint,
  FaPuzzlePiece,
  FaWallet,
  FaClipboardCheck,
  FaCogs,
  FaCheckCircle,
  FaPlus,
  FaMinus,
  FaSync,
} from "react-icons/fa";

// ---- Stats Section ----
const StatsSection = () => {
  const stats = [
    { number: "20+", label: "Integration Supports" },
    { number: "100K+", label: "Happy Merchants" },
    { number: "10+", label: "Payment Methods" },
    { number: "24/7+", label: "Support Team" },
  ];
  return (
    <div className="stats-container">
      {stats.map((item, index) => (
        <div key={index} className="stat-item">
          <h2 className="stat-number">{item.number}</h2>
          <p className="stat-label">{item.label}</p>
        </div>
      ))}
    </div>
  );
};

// ---- About Section ----
const AboutSection = () => (
  <section className="egf-section">
    <div className="egf-container">
      {/* ===== Left Content ===== */}
      <div className="egf-left">
        <h2 className="egf-title">
          Simplifying Digital Payments with Omeswara
        </h2>

        <p className="egf-text">
          At Omeswara, we’re on a mission to redefine how businesses manage
          payments. We provide secure, fast, and intelligent digital payment
          solutions designed for startups, SMEs, and enterprises across India.
          As a reliable payment gateway provider, we help businesses streamline
          their entire payment flow—from collections to settlements—with
          unmatched efficiency.
        </p>

        <p className="egf-text">
          Our platform is engineered for high performance, scalability, and
          seamless integration. Whether you're searching for a robust payment
          gateway in India or a trusted partner to power your digital
          transactions, Omeswara simplifies everything with smart, secure, and
          modern payment technology.
        </p>
      </div>

      {/* ===== Right Certificate Image ===== */}
      <div className="egf-right">
        <img src={certificateImg} alt="EGF Certificate" className="egf-img" />
      </div>
    </div>
  </section>
);

// ---- Features Section ----
const FeaturesSection = () => {
  return (
    <section className="features-section">
      <div className="features-container">
        <div className="feature-box">
          <FaSync className="feature-icon" />
          <h3>Easy API Integration</h3>
          <p>
            Integrate our payment gateway effortlessly using developer-friendly
            APIs.
          </p>
        </div>

        <div className="feature-box">
          <FaChartPie className="feature-icon" />
          <h3>Real-Time Settlements</h3>
          <p>
            Experience fast and reliable real-time settlements for businesses
            across India.
          </p>
        </div>

        <div className="feature-box">
          <FaGem className="feature-icon" />
          <h3>Multi-Channel Payment</h3>
          <p>
            Offer customers multiple payment options for flexibility and
            convenience.
          </p>
        </div>

        <div className="feature-box">
          <FaMapMarkerAlt className="feature-icon" />
          <h3>Secure and PCI-DSS</h3>
          <p>We ensure 100% secure transactions with PCI-DSS compliance.</p>
        </div>
      </div>
    </section>
  );
};

// ---- Services Section ----
const ServicesSection = () => (
  <section className="services-section text-center">
    <p className="services-subtitle">Services We Offer</p>
    <h1 className="services-title">
      End-to-End Digital Payment <br /> Solutions
    </h1>
    <p className="services-desc">
      Manage collections, transfers, settlements, accounts, and wallets—all in
      one unified platform.
    </p>
  </section>
);

// ---- Our Services Section ----
const OurServicesSection = () => {
  const services = [
    {
      icon: <FaClipboardCheck size={45} color="#3b3fc9" />,
      title: "BBPS (Bharat BillPay) Services",
      desc: "Offer secure, convenient bill payments across utility, telecom, insurance, and other everyday services through one reliable platform.",
    },
    {
      icon: <FaFingerprint size={45} color="#3b3fc9" />,
      title: "AEPS (Aadhaar Enabled Payment System)",
      desc: "Enable secure transactions using Aadhaar authentication—trusted across India for hasslefree withdrawals, deposits, and balance checks.",
    },
    {
      icon: <FaPuzzlePiece size={45} color="#3b3fc9" />,
      title: "Micro ATM (MATM) Services",
      desc: "Offer cash withdrawals and balance inquiries through Micro ATM devices—perfect for rural and semi-urban business operations",
    },
    {
      icon: <FaWallet size={45} color="#3b3fc9" />,
      title: "DMT (Domestic Money Transfer)",
      desc: "Provide fast and reliable domestic money transfers across India with Omeswara’s highly secure remittance infrastructure.",
    },
  ];

  return (
    <section className="our-services-section py-5">
      <div className="container text-center">
        <div className="row justify-content-center">
          {services.map((service, index) => (
            <div key={index} className="col-lg-3 col-md-6 col-sm-12 mb-4">
              <div className="service-card p-4 h-100">
                <div className="icon-wrapper mb-3">{service.icon}</div>
                <h6 className="service-title">{service.title}</h6>
                <p className="service-desc" style={{ fontSize: "12px" }}>
                  {service.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

// ---- Why Choose Omeswar ----
const WhyChooseSection = () => (
  <section className="whychoose-section text-center">
    <p className="whychoose-subtitle">Why Choose Omeswar?</p>
    <h1 className="whychoose-title">
      Why Businesses Across India <br /> Trust Omeswara
    </h1>
    <p className="whychoose-desc">
      It’s simpler than you think—start accepting and managing payments in just
      3 easy steps
    </p>
  </section>
);

// ---- Why Choose Features ----
const WhyChooseFeatures = () => {
  const features = [
    {
      icon: <FaClipboardCheck size={45} color="#3b3fc9" />,
      title: "24/7 Uptime Fast Settlements & High Security",
      desc: "Enjoy uninterrupted services backed by real-time settlements, bank-grade encryption, and top-level security protocols.",
    },
    {
      icon: <FaCogs size={45} color="#3b3fc9" />,
      title: "Seamless API Integration for Easy Setup",
      desc: "Omeswara’s robust API structure enables fast onboarding and smooth integration into any existing system.",
    },
    {
      icon: <FaWallet size={45} color="#3b3fc9" />,
      title: "Scalable Solutions for Startups to Enterprises",
      desc: "Whether you're a new business or an established brand, our platform adapts to your growth and volume needs.",
    },
    {
      icon: <FaCheckCircle size={45} color="#3b3fc9" />,
      title: "PAN India Coverage with Dedicated Support",
      desc: "Benefit from nationwide service availability and a dedicated support team offeringconsistent, reliable assistance anytime you need it",
    },
  ];

  return (
    <section className="whychoose-features-section py-5">
      <div className="container text-center">
        <div className="row justify-content-center align-items-start">
          {features.map((feature, index) => (
            <div key={index} className="col-lg-3 col-md-6 col-sm-12 mb-4">
              <div className="service-card p-4 h-100">
                <div className="icon-wrapper mb-3">{feature.icon}</div>
                <h6 className="service-title">{feature.title}</h6>
                <p className="service-desc" style={{ fontSize: "12px" }}>
                  {feature.desc}
                </p>
              </div>

              {index < features.length - 1 && (
                <div className="arrow-connector d-none d-lg-block">➜</div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

// ---- FAQ Section ----
const faqs = [
  {
    question: "What is Omeswar ?",
    answer:
      "Omeswara is a powerful payment gateway platform that enables businesses to accept and process payments securely through UPI, cards, net banking, mobile wallets, and more. It also provides complete tools for managing settlements, tracking transactions, and simplifying payment operations.",
  },

  {
    question: "Is Omeswar Safe & Secure ?",
    answer:
      "Absolutely. Omeswara uses advanced encryption, authentication protocols, and PCI-DSS compliance to ensure every transaction is fully protected and secure.",
  },
  {
    question: "What Types of Payments Can Be Made Through Omeswar?",
    answer:
      "Omeswara onboards all merchant categories except government-restricted or high-risk industries like gambling and other prohibited gaming platforms. We process all valid payments under Indian regulations with verified KYC merchants only.",
  },
  {
    question: "What If I have An Issue With Omeswar Transaction?",
    answer:
      "You can reach out to our support team anytime. We assist with payment issues, refunds, chargebacks, settlement queries, and any other transaction-related concerns.",
  },
  {
    question: "How Long Does It Take For Funds To Be Transferred?",
    answer:
      "Settlement time may vary based on the payment mode and bank processing. Generally, most transactions are settled within T+0, T+1, or T+2 cycles.",
  },

  {
    question: "Are There Any Fees Associated With Using Omeswar?",
    answer:
      "Yes, Omeswara charges applicable transaction and service fees based on the plan, payment method, and merchant category. Charges vary according to business volume and industry type.",
  },
];

function FAQSection() {
  const [activeIndex, setActiveIndex] = useState(null);
  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section className="faq-section py-5">
      <div className="container text-center">
        <p className="faq-subtitle">Frequently Asked Questions</p>
        <h1 className="faq-title">
          If you got <span>questions</span> we have <span>answer</span>
        </h1>
        <div className="faq-container row justify-content-center mt-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="col-lg-5 col-md-6 col-sm-12 mb-4 faq-card"
              onClick={() => toggleFAQ(index)}
            >
              <div className="faq-question">
                <h6>{faq.question}</h6>
                <span className="faq-icon">
                  {activeIndex === index ? <FaMinus /> : <FaPlus />}
                </span>
              </div>
              {activeIndex === index && (
                <div className="faq-answer">
                  <p>{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

// ---- Landing Page ----
const LandingPage = () => {
  return (
    <div>
      {/* Hero Section */}
      <section
        className="hero-section"
        style={{ backgroundImage: `url(${bgImage})` }}
      >
        <div className="overlay">
          <p className="tagline">Trusted by over 10k+ customers</p>
          <h2 className="title">
            One Smart Platform for All Your Digital Payment Needs
          </h2>

          <p className="description">
            Experience effortless and secure digital transactions with Omeswara
            — India’s trusted partner for BBPS, AEPS, Micro ATM, and DMT
            services. Sign Up Now
          </p>

          <button className="play-btn">Sign UP Now</button>
        </div>
      </section>
      {/* Sections Order */}
      <StatsSection />
      <AboutSection />
      <FeaturesSection />
      <ServicesSection />
      <OurServicesSection />
      <WhyChooseSection />
      <WhyChooseFeatures />
      {/* <TestimonialsHeading /> */}
      {/* <TestimonialsSlider /> */}
      <FAQSection /> {/* ✅ FAQ section added below testimonials */}
    </div>
  );
};

export default LandingPage;
